import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router, Route, Switch } from 'react-router-dom';
import { Group, TextInput, Button, Stack, PasswordInput, Popover, Progress, Image, Text, Box } from '@mantine/core';
import {set_profile_data, set_loader} from '../../../redux/action/General/generalActions';
import Logo from '../../../assests/svg/Logo.svg';
import EyeIcon from '../../../assests/svg/EyeIcon.svg';
import { TenantActivationStatusPost, TenantResetPasswordPost } from '../../../helpers/fetchApis/Auth';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../assests/svg/RedCross.svg';

// Password requirement markup
const PasswordRequirement = ({ checks, label }) => {
    return (
      <Text
        color="white"
        sx={{ display: 'flex', alignItems: 'center', opacity: checks ? 1 : 0.5 }}
        mt={7}
        size="sm"
      >
        <Image width={15} src={`${process.env.PUBLIC_URL}/icons/icon-check-badge.svg`} alt="Check icon" />
        <Box ml={10}>{label}</Box>
      </Text>
    )
};

// Requirements for the password validation
const passwordRequirements = [
    { regex: /[0-9]/, label: 'Eine Nummer haben' },                                                 // one digit
    { regex: /[a-z]/, label: 'Mindestens einen Kleinbuchstaben haben' },                            // lowercase letter
    { regex: /[A-Z]/, label: 'Mindestens einen Großbuchstaben haben' },                             // uppercase letter
    { regex: /[$&+,:;=?@#|'<>.^*()%!-]/, label: 'Ein Sonderzeichen enthalten (z. B. %, &, #)' }     // special chars
  ];
  
// Show password strength
const getStrength = (password) => {
    let multiplier = password.length > 5 ? 0 : 1;

    passwordRequirements.forEach((requirement) => {
    if (!requirement.regex.test(password)) {
        multiplier += 1;
    }
    });

    return Math.max(100 - (100 / (passwordRequirements.length + 1)) * multiplier, 10);
}


class SignUp extends Component {

    state={
        visible: false,
        password: '',
        confirmPassword: '',
        email: '',
        passwordResetCode: '',
        activationStatus: {},
        welcomeScreen: true,
        passwordPopoverOpened: false,
        isEmailVerified: false
    }
    checks =()=> passwordRequirements.map((requirement, index) => (
        <PasswordRequirement key={index} label={requirement.label} checks={requirement.regex.test(this.state.password)} />
    ));
    strength =()=> getStrength(this.state.password);
    color =()=> this.strength() === 100 ? 'teal' : this.strength() > 50 ? 'yellow' : 'red';
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        let url = new URL(window.location.href)
        this.setState({passwordResetCode: url.search.split('?')[1]}, ()=>{
            TenantActivationStatusPost({passwordResetCode: url.search.split('?')[1]}, this.props.set_loader, res=>{
                console.log('TenantActivationStatusPost: ', res);
                if(res.isActivated === true && res.isEmailVerified === false){
                    window.localStorage.setItem('signupEmail', res.email);
                    window.location.href='/emailVerification';
                }else if(res.isActivated === true && res.isEmailVerified === true){
                    this.setState({isEmailVerified: true, welcomeScreen: false});
                }
            })
        });
    }

    handlePasswordChange=(e)=>{
        this.setState({password: e.currentTarget.value});
    }

    handleConfirmPassword=(e)=>{
        this.setState({confirmPassword: e.currentTarget.value});
    }

    handleSubmit=(e)=>{
        e.preventDefault();
        this.props.set_loader(true);
        const {password, confirmPassword, email, passwordResetCode} = this.state;
        console.log('submitworking');
        //window.location.href='/login';
        if(password === confirmPassword){
            TenantResetPasswordPost({passwordResetCode: passwordResetCode, newPassword: password}, this.props.set_loader, res=> {
                window.localStorage.setItem('signupEmail', res.email);
                this.props.set_loader(false);
                window.location.href='/emailVerification';
            })
        }else{
            showNotification({
                message: 'Passwort stimmt nicht überein.',
                icon: <img src={RedCross} alt='red-tick'/>,
            });
            this.props.set_loader(false);
        }
    }

    setPasswordPopoverOpened=(value)=>{
        this.setState({passwordPopoverOpened: value});
    }

    render() {
        const {visible, password, email, passwordResetCode, confirmPassword, welcomeScreen, passwordPopoverOpened, isEmailVerified} = this.state;
        console.log('visible: ', email, passwordResetCode);
        return (
        <>
            <Stack className="login-view" id="respond-dashboard-page" style={{justifyContent: 'center', alignItems: 'center'}}>
                <img src={'./hello-housing-logo.svg'} alt='hello-housing' style={{marginBottom: '30px'}}/>
                {welcomeScreen ?
                <Stack className='card' spacing={15} style={{width: '340px'}}>
                    <Group><span className='card-title'>Willkommen</span></Group>
                    <Group><span className='card-sub-text'>Herzlich Willkommen bei Ihrem Mieterportal! Hier richten Sie in wenigen Schritten Ihren persönlichen Zugang zum Mieterportal ein.</span></Group>
                    <Group grow>
                        <Button className='purple-btn btn-app-text' onClick={()=> this.setState({welcomeScreen: false})}>Nächster Schritt: Passwort festlegen</Button>
                    </Group>
                </Stack>
                :
                isEmailVerified ?
                <Stack className='card' spacing={10} style={{width: '340px'}}>
                    <Group><span className='card-title'>Willkommen</span></Group>
                    <Group><span className='card-sub-text'>Diese E-Mail ist bereits verifiziert. Bitte loggen Sie sich ein oder verwenden Sie Passwort vergessen, wenn Sie Ihr Passwort verloren haben.</span></Group>
                    <Group grow>
                        <Button className='purple-btn btn-app-text' onClick={()=> window.location.href='/login'}>Zur Anmeldung</Button>
                    </Group>
                </Stack>
                :
                <Stack className='card' spacing={10} style={{width: '340px'}}>
                    <Group><span className='card-title'>Passwort festlegen</span></Group>
                    <Group><span className='card-sub-text' style={{fontWeight: '500'}}>Schritt 1 von 2</span></Group>
                    <Group><span className='card-sub-text'>Bitte legen Sie ein Ihr Passwort für das Mieterportal fest. Sie nutzen dieses Passwort und Ihre Email-Adresse später für die Anmeldung.</span></Group>
                    <Group>
                        <form onSubmit={this.handleSubmit}>
                            <Stack style={{width: '304px'}}>
                                <Group grow>
                                    {/* <PasswordInput
                                        label="Passwort"
                                        value={password}
                                        onChange={this.handlePasswordChange}
                                        visibilityToggleIcon={({ reveal, size }) =>
                                        reveal ? <img src={EyeIcon} size={size} /> : <img src={EyeIcon} size={size} />
                                        }
                                    /> */}
                                    {/* Password input with strength popover */}
                                    <Popover
                                        opened={passwordPopoverOpened}
                                        // target={
                                        // // <PasswordInput 
                                        // //     label="Passwort" {...form.getInputProps('password')}
                                        // //     styles={{ label: { color: "#727293" } }}
                                        // //     visibilityToggleIcon={({ reveal, size }) =>
                                        // //     reveal ? <EyeOpened size={size} /> : <EyeOpened size={size} />
                                        // //     }
                                        // //     required 
                                        // // />
                                        // }
                                        position={window.innerWidth < 993 ? "top" : "left"}
                                        placement="center"
                                        trapFocus={false}
                                        transition="pop"
                                        onFocusCapture={() => this.setPasswordPopoverOpened(true)}
                                        onBlurCapture={() => this.setPasswordPopoverOpened(false)}
                                        styles={(theme) => ({
                                        dropdown: { width: '100%', backgroundColor: 'rgb(19, 19, 92)' },
                                        arrow: { backgroundColor: 'rgb(19, 19, 92)', border: 'none' },
                                        body: { border: 'none' }
                                        }) }
                                        withArrow
                                    >
                                        <Popover.Target>
                                            <PasswordInput
                                            label="Passwort"
                                            value={password}
                                            onChange={this.handlePasswordChange}
                                            visibilityToggleIcon={({ reveal, size }) =>
                                            reveal ? <img src={EyeIcon} size={size} /> : <img src={EyeIcon} size={size} />
                                            }
                                            required
                                            />
                                        </Popover.Target>
                                        <Popover.Dropdown className='password-popover' style={{paddingLeft: '20px'}}>
                                            <Progress color={this.color()} value={this.strength()} size={7} style={{ marginBottom: 16, border: '1px solid white' }} />
                                            <PasswordRequirement label="Mindestens 8 Zeichen lang sein" checks={password.length > 8} />
                                            {this.checks()}
                                        </Popover.Dropdown>
                                    </Popover>
                                </Group>
                                <Group grow>
                                    <PasswordInput
                                        label="Passwort bestätigen"
                                        value={confirmPassword}
                                        onChange={this.handleConfirmPassword}
                                        visibilityToggleIcon={({ reveal, size }) =>
                                        reveal ? <img src={EyeIcon} size={size} /> : <img src={EyeIcon} size={size} />
                                        }
                                    />
                                </Group>
                                <Group grow>
                                    <Button className='purple-btn btn-app-text' type="submit">Nächster Schritt: Email bestätigen</Button>
                                </Group>
                            </Stack>
                        </form>
                    </Group>
                </Stack>}
            </Stack>
        </>
        );
    }
}

const actions = {
    set_profile_data,
    set_loader
};

export default connect(null, actions)(SignUp);
